/*
 * View for the details of a conversation transcript (Date, Id, TouchPoint...)
 */

define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "modules/learner/learnerTranscriptModal/conversationTranscriptDetails/template/conversationTranscriptDetailsTemplate.html",
], function ($, Marionette, Messenger, ConversationTranscriptDetailsTemplate) {
  "use strict";

  const ConversationTranscriptDetailsView = {};

  ConversationTranscriptDetailsView.conversationTranscriptDetailsView = Marionette.ItemView.extend({
    template: ConversationTranscriptDetailsTemplate,
    events: {
      "click a": function (e) {
        //get the intent id of the topic by getting the custom data attribute
        const intentId = $(e.target).attr("data-topic-id");
        //stop the propagation of this event so that we don't actually have the link behavior occur
        e.preventDefault();
        e.stopPropagation();
        if (intentId !== "tmlDisabled") {
          this.trigger("click:topic:match", intentId);
        }
      },
    },
    templateHelpers: {
      getDateTimeDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:dateTime:long", date);
      },
    },
  });

  return ConversationTranscriptDetailsView;
});
